module["exports"] = [];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/name/suffix.js
// module id = 1807
// module chunks = 0